import React, {useState,Fragment, useEffect} from 'react';
import { SINGLE_POST_PAGE } from 'settings/constant';
import SectionGrid from 'components/SectionGrid/SectionGrid';
import Heading from 'components/UI/Heading/Heading';
import { PostPlaceholder } from 'components/UI/ContentLoader/ContentLoader';
import { PostsWrapper,Title, LoadMoreWrapper, SearchInputWrapper } from './Listing.style';
import { Button, Col, Row } from 'antd';
import Search from 'antd/es/input/Search';

const ListingGrid = ({title,currency,data,loading,listHotel, loadMoreChambre, diplayLoadMoreBtn, setSearchInput, searchInputLoading, diplayLoaderToLoadMoreBtn,
  linkClicked
}) =>  {
    let columnWidth = [1 / 1, 1 / 2, 1 / 3, 1 / 4, 1 / 5];
    const [loader , setLoader] = useState(false) ;
    const [hotel , setHotel] =useState(data);
    const [localDiplayLoadMoreBtn, setLocalDiplayLoadMoreBtn]=useState(diplayLoadMoreBtn);

    useEffect(() => {
      setLocalDiplayLoadMoreBtn(diplayLoadMoreBtn);
    }, [diplayLoadMoreBtn])

    useEffect(() => {
      setHotel(data)
    }, [data])

    useEffect(() => {
      if (listHotel) setHotel(listHotel)
    }, [listHotel])
    
  var contentStyle= {
    //  fontSize: '15px',
      fontWeight: '400',
      color: 'grey',
      lineHeight: '1.6',
      marginTop : '20px !important',
      textAlign : 'center',
      mt : '100px',
      mb: [ '14px', '20px', '27px'],
    }

    return (
        <Fragment>
              <PostsWrapper>
                <Row>
                <Title>{title}</Title>
                  <Col className='right-align' md={6} xs={24}>
                    <SearchInputWrapper>
                        <Search
                            onChange={(e) => setSearchInput(e.target.value)}
                            placeholder='Rechercher ...'
                            loading={searchInputLoading}
                            enterButton={false}
                            />
                    </SearchInputWrapper>
                  </Col> 
                </Row>
              
              {
                hotel.length > 0 ?
                <div>
                  <SectionGrid
                  link={SINGLE_POST_PAGE}
                  columnWidth={columnWidth}
                  data={hotel}
                  currency= {currency}
                  // totalItem="50"
                  loading={loading}
                  linkClicked={linkClicked}
                  // limit={limit}
                  // handleLoadMore={loadMoreData}
                  placeholder={<PostPlaceholder />}
                />
                  {
                    localDiplayLoadMoreBtn && (
                      <LoadMoreWrapper>
                        <Button 
                          loading={diplayLoaderToLoadMoreBtn} 
                          onClick={()=> loadMoreChambre()}>
                          {'Afficher plus'}
                        </Button>
                      </LoadMoreWrapper>
                    )
                  }
                </div>
              : <Heading as="h2" content="Aucune réservation n'est disponible selon vos critères. De nouvelles offres seront bientôt en ligne !" {...contentStyle} />}
              </PostsWrapper>
        </Fragment>
    )

}

export default ListingGrid;